var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Card 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3932 13.5837H9.72656M6.97656 13.5837H5.14323M1.48669 7.16699C1.47656 7.69593 1.47656 8.30042 1.47656 9.00033C1.47656 11.5672 1.47656 12.8507 1.97612 13.8311C2.41554 14.6935 3.1167 15.3947 3.97911 15.8341C4.95953 16.3337 6.24299 16.3337 8.8099 16.3337H12.4766C15.0435 16.3337 16.3269 16.3337 17.3074 15.8341C18.1698 15.3947 18.8709 14.6935 19.3103 13.8311C19.8099 12.8507 19.8099 11.5672 19.8099 9.00033C19.8099 8.30042 19.8099 7.69593 19.7998 7.16699M1.48669 7.16699C1.5137 5.75604 1.61277 4.88264 1.97612 4.16954C2.41554 3.30713 3.1167 2.60597 3.97911 2.16655C4.95953 1.66699 6.24299 1.66699 8.8099 1.66699H12.4766C15.0435 1.66699 16.3269 1.66699 17.3074 2.16655C18.1698 2.60597 18.8709 3.30713 19.3103 4.16954C19.6737 4.88264 19.7728 5.75604 19.7998 7.16699M1.48669 7.16699H19.7998",
    stroke: "#1A1A1A",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayStatus);
export default __webpack_public_path__ + "static/media/pay-status.12c41700.svg";
export { ForwardRef as ReactComponent };